import "./HomePage.css"

export default function HomePage(){
    return(
        <div className="home-page">
            <div className="home-page__text-container">
                <h1>Have you ever thought how cool it would be to have a real life minecraft block?</h1>
                <p>We did and unfortunately it would be either impossible or not viable for a successful business. Can you even imagine how hard it would be to make a pure cube of 1m³ of diamond or gold?</p>
                <p>Unfortunately this store is just a fake e-shop so I can practice some React.js skills  recently learned on The Odin Project course. Feel free to explore and just play with it</p>
            </div>
        </div>
    )
}